const onRun = () => {
    // HP - Top products
    const hpProductsWrap = document.querySelector('.hp-products');
    let hpProducts = Array.from(document.querySelectorAll('.product-card'));

    if (hpProductsWrap !== null) {
        const topProduct = hpProductsWrap.querySelector('.hp-products__content');

        function hideOtherCountries(countryId) {
            hpProducts.forEach(topProduct => {
                const rowCountryId = topProduct.dataset.countryId;
                topProduct.classList.toggle('hidden', countryId !== undefined && rowCountryId !== countryId);
            });
        }

        // Get all country buttons
        const countryButtons = document.querySelectorAll('.hp-products__badges .hp-products__badge');

        // Attach click event listener to each button
        countryButtons.forEach(button => {
            button.addEventListener('click', function() {
                const countryId = this.dataset.countryId;

                // Remove 'is-active' class from all other buttons
                countryButtons.forEach(btn => btn.classList.toggle('is-active', btn === button));

                hideOtherCountries(countryId);
            });
        });
    }

};
if(document.readyState !== 'loading') {
    onRun();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        onRun()
    });
}

